// Helpers to keep the Lovable preview shell's "Drop files here to add to
// your message" overlay from getting stuck after our editor consumes a
// native file drop.
//
// The real fix is `suppressHostFileDrag`: calling preventDefault +
// stopPropagation + stopImmediatePropagation on the React drag events at
// the composer drop targets so the host overlay never sees them in the
// first place.
//
// `notifyHostDropHandled` previously dispatched a burst of synthetic
// DragEvents on window/document/body and postMessaged invented payloads
// (`drop-handled`, `lovable:drop-handled`, `drag-reset`) at window.parent.
// Both were speculative — we never confirmed the host's contract — and
// were the likely cause of the Lovable chat shell intermittently whiting
// out while interacting with the composer. It is now a no-op, kept only
// so existing call sites compile; remove the import opportunistically.

type AnyDragEvent = {
  preventDefault: () => void;
  stopPropagation: () => void;
  stopImmediatePropagation?: () => void;
};

export function notifyHostDropHandled(): void {
  /* intentional no-op — see file header */
}

export function suppressHostFileDrag(e: AnyDragEvent): void {
  try {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();
  } catch {
    /* ignore */
  }
}
